import { Component, Input } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

@Component({
  selector: 'menu-item',
  templateUrl: './menu-item.component.html',
  styleUrls: ['./menu-item.component.scss'],
  imports: [RouterLink, RouterLinkActive],
})
export class MenuItemComponent {
  @Input('icon-src') public iconSrc: any;

  @Input() public route: any;

  @Input() public label: any;

  constructor() {}
}
